import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {TypedForm, TypedFormOwnControls} from '../../../common/form-types';
import {WidgetImplSettingsComponentBase} from '../../components/widget-impl-settings-component-base';
import {DexLpDetailsWidget} from '../dex-lp-details-widget';
import {DexLpDetailsWidgetSettings} from './dex-lp-details-widget-settings';

interface SettingsFormValue {
    title: string;
}

@Component({
    selector:    'dex-lp-details-widget-settings',
    templateUrl: './dex-lp-details-widget-settings.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone:  false
})
export class DexLpDetailsWidgetSettingsComponent extends WidgetImplSettingsComponentBase<DexLpDetailsWidget> {

    @Input()
    public override widget: DexLpDetailsWidget;

    public form: TypedForm<SettingsFormValue>;

    protected override buildForm(): void {
        const settings: DexLpDetailsWidgetSettings = this.widget.implementationInstance.settings;

        const controls: TypedFormOwnControls<SettingsFormValue> = {
            title:   this.createTitleFormControl(settings)
        };

        this.form = new FormGroup(controls) as TypedForm<SettingsFormValue>;
    }

}
